"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _helpers = require("../../helpers");

var _InfoIcon = _interopRequireDefault(require("../CampaignCreator/InfoIcon"));

var _index = require("../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GroupedPersonaTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GroupedPersonaTable, _React$Component);

  function GroupedPersonaTable(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleSortChange", function (clickedColumn) {
      return function () {
        return (0, _helpers.sortChangeHandler)(clickedColumn, _assertThisInitialized(_this));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "sort", function (a, b) {
      return (0, _helpers.sortData)(a, b, _assertThisInitialized(_this));
    });

    _this.state = {
      sortColumn: 'index',
      sortDirection: 'descending'
    };
    return _this;
  }

  var _proto = GroupedPersonaTable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        groupedPersonaRecords = _this$props.groupedPersonaRecords,
        theme = _this$props.theme,
        isFetching = _this$props.isFetching,
        filters = _this$props.filters;
    var _this$state = this.state,
        sortColumn = _this$state.sortColumn,
        sortDirection = _this$state.sortDirection;
    var shareOfAttribute = filters.shareOfAttribute,
        shareOfAudience = filters.shareOfAudience,
        index = filters.index,
        population = filters.population; // conditionally check the groupedPersonaRecords
    // to ensure there is data before attempting to render a table

    if (groupedPersonaRecords !== undefined && groupedPersonaRecords[0]) {
      var maxIndex = 100;

      if (groupedPersonaRecords) {
        maxIndex = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'index');
      }

      var TableHeader = /*#__PURE__*/React.createElement(_semanticUiReact.Table.Header, {
        className: "data-workflow-table__header"
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, {
        style: {
          paddingTop: '20px'
        }
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        width: 3,
        sorted: sortColumn === 'questionLabel' ? sortDirection : null,
        onClick: this.handleSortChange('questionLabel')
      }, "Category"), /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        width: 3,
        sorted: sortColumn === 'answerLabel' ? sortDirection : null,
        onClick: this.handleSortChange('answerLabel')
      }, "Attribute"), /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        width: 3,
        sorted: sortColumn === 'index' ? sortDirection : null,
        onClick: this.handleSortChange('index')
      }, /*#__PURE__*/React.createElement(_InfoIcon["default"], null, "The index is a measure of the propensity of the Audience to possess an attribute, relative to the complete universe. It is expressed as a proportional likelihood, based to 100. For instance: the Audience has an index of 200 for the row where the attribute is Smoker. This would mean that the Audience is twice as likely to smoke as the population at large."), "Index"), /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        width: 1,
        style: {
          textAlign: 'center',
          paddingRight: '9px'
        },
        sorted: sortColumn === 'shareOfAudience' ? sortDirection : null,
        onClick: this.handleSortChange('shareOfAudience')
      }, /*#__PURE__*/React.createElement(_InfoIcon["default"], null, "Within the defined Audience, what percentage have the attribute defined by each row. For instance: what percentage of my Audience are smokers?"), "Share of", /*#__PURE__*/React.createElement("br", null), "Audience"), /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        width: 1,
        style: {
          textAlign: 'center',
          paddingRight: '9px'
        },
        sorted: sortColumn === 'shareOfProperty' ? sortDirection : null,
        onClick: this.handleSortChange('shareOfProperty')
      }, /*#__PURE__*/React.createElement(_InfoIcon["default"], null, "Within the total universe defined by the attribute of each row, what portion of that universe does this Audience represent. For instance: what percentage of smokers are within my defined Audience?"), "Share of", /*#__PURE__*/React.createElement("br", null), "Attribute"), /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        width: 1,
        style: {
          textAlign: 'center',
          paddingRight: '9px'
        },
        sorted: sortColumn === 'population' ? sortDirection : null,
        onClick: this.handleSortChange('population')
      }, /*#__PURE__*/React.createElement(_InfoIcon["default"], null, "The population is the number of people within the defined Audience for whom the row Attribute is true. For instance: how many smokers are there within my Audience?"), "Pop.")));
      var rows = Object.values(groupedPersonaRecords).sort(this.sort); // Filtering of Results
      // Filter results on Share of Attribute

      if (shareOfAttribute && parseFloat(shareOfAttribute) > 0) {
        rows = rows.filter( // $FlowFixMe
        function (row) {
          return row.shareOfProperty > parseFloat(shareOfAttribute);
        });
      } // Filter results on Share of Audience


      if (shareOfAudience && parseFloat(shareOfAudience) > 0) {
        rows = rows.filter( // $FlowFixMe
        function (row) {
          return row.shareOfAudience > parseFloat(shareOfAudience);
        });
      } // Filter results on Index


      if (index && parseFloat(index) > 0) {
        // $FlowFixMe
        rows = rows.filter(function (row) {
          return row.index > parseFloat(index);
        });
      } // Filter results on Population


      if (population && parseFloat(population) > 0) {
        rows = rows.filter( // $FlowFixMe
        function (row) {
          return row.population > parseFloat(population);
        });
      } // Filter results on Theme


      if (theme && theme.length) {
        var categoryFilterVals = theme.map(function (item) {
          return item.categoryLabel;
        });
        rows = rows.filter(function (row) {
          return categoryFilterVals.includes(row.categoryLabel);
        });
      }

      return isFetching ? /*#__PURE__*/React.createElement(_index.LoadingIndicator, null) : /*#__PURE__*/React.createElement(_semanticUiReact.Table, {
        sortable: true,
        stackable: true,
        striped: true,
        className: "grouped-persona-table"
      }, TableHeader, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Body, null, rows.length && rows.map(function (record, key) {
        return /*#__PURE__*/React.createElement(_TableRow["default"], {
          key: key,
          record: record,
          maxIndex: maxIndex
        });
      }) || /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, {
        className: "data-workflow-table__row"
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, {
        colSpan: 6,
        className: "data-workflow-table__empty-table"
      }, "No results available."))));
    } else {
      return /*#__PURE__*/React.createElement("h3", {
        className: "data-workflow-table__no-results"
      }, "Select personas from the menu on the left to view data");
    }
  };

  return GroupedPersonaTable;
}(React.Component);

exports["default"] = GroupedPersonaTable;